import './App.css';
import {Header, NotificationBanner} from "./components/header";
import {BodyContainer, Highlights} from "./components/content";
import {Projects} from "./components/project";
import {Footer} from "./components/footer";
import {ProfileCard} from "./components/profile";
import React, {useEffect, useState} from "react";
import {getData} from "./utils/data";
import {RouterProvider, createBrowserRouter} from "react-router-dom";
import {SkillSectionList} from "./components/skills";
import {Timeline} from "./components/timeline";



function App() {
    const [data, setData] = useState({mount:false})
    const HighLights = data.map && <Highlights {...data.map.home[0]}/>
    const Skills=data&&<SkillSectionList {...data}/>
    const Education=data.map&&<Timeline timelineContent= {data.map.education}/>
    const Experience=data.map&&<Timeline timelineContent={data.map.experience}/>
    const ProjectList=data.map&&<Projects {...data.map}/>

    const RootComp=(comp)=> (<React.Fragment>
        {data.navigation && <div><Header {...data}/>
            {data.messages.incident.message && <NotificationBanner {...data}/>}
            {comp===HighLights&&<ProfileCard {...data}/>}
            <BodyContainer comp={[comp]}/>
            <Footer {...data}/>
        </div>}
    </React.Fragment>)
    const router = createBrowserRouter([
        {
            path: "/skills",
            element: (
                RootComp(Skills)
            ),
        },
        {
            path: "/",
            element: RootComp(HighLights),
        },
        {
            path: "/experience",
            element: RootComp(Experience),
        },
        {
            path: "/education",
            element: RootComp(Education),
        },
        {
            path: "/projects",
            element: RootComp(ProjectList),
        },
    ]);


    useEffect(() => {
            getData().then(res => {
                setData(res.data)
            })

    }, [])

    return (
        <div className="App">

                {data.navigation && <div>

                    <RouterProvider router={router} />

                </div>}


        </div>

    );
}

export default App;
